import React from "react";
import { Dashboard } from "./dashboard/Dashboard";
import { KpiPercentiles } from "./Percentile/KpiPercentiles";
import { FilterSelections } from "../../common/filterSelections/filterSelection";
import { useNavigate, useParams } from "react-router-dom";
import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Container } from "@mui/material";
import { Financial } from "../benchmark/financials/Financial";
import { InSights } from "./InSights/InSights";
import logger from "../../common/utils/logger";

export const OverViewPage = () => {
  const navigate = useNavigate();
  const url = new URL(window.location.href);
  const [sectorData, setSectorData] = React.useState([]);
  const [kpiData, setKpiData] = React.useState([]);
  const [viewFilter, setViewFilter] = React.useState("period");
  const [isLoading, setIsLoading] = React.useState(false);
  const { sector } = useParams();
  const sectorID = parseInt(url.searchParams.get('sector'));
  const [tab, setTab] = React.useState("1");
  const [getInsightsFilter, setInsightsFilter] = React.useState({});
  const [financial, setFinancialData] = React.useState({});
  const [sectDataToSend, setSectData] = React.useState({});
  const [childData, setChildData] = React.useState(null);
  const [filterCopy, setfiltercopy] = React.useState({
    selectedCCS:0,
    selectedCountry: 0,
    selectedFunction: 0,
    selectedRegion: 0,
    selectedRevenue: 0,
    selectedSector: 0,
    selectedSubSector: 0,
    subSubSectorID:0,
    selectedArea:0

  });

  const getInitialData = (tabValue) => {
    if(tabValue !== "3"){
      setIsLoading(true);
      apiQueryWithToken
        .post(
          tabValue === "1"
            ? `api/Insights/Sector/Overview`
            : `api/Insights/Sector/Benchmark`,
          {
            sectorID: getInsightsFilter.selectedSector || sector,
            subSectorID: 0,
            subSubSectorID: 0,
            areaID:0,
            countryID: 0,
            regionID: 0,
            ccsid: 0,
            functionID: 0,
            revenueRangeID: 0,
            top: 3
          }
        )
        .then((data) => {
          if (tabValue === "1") {
            setSectorData(data.data.period?.averageRevenue?.yearlyInsights);
            setKpiData(data.data.kpiPercentiles);
          } else if (tabValue === "2") {
            setFinancialData(data.data.financial);
            setSectData({ Financial: { ...data.data.financial } });
          }
          setIsLoading(false);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            navigate("/");
          } else {
            logger.error("An error occurred:", error);
            setIsLoading(false);
          }
        });
    }
  }
  const handleData = (value) => {
      setInsightsFilter(value);
      if(tab !== "3"){
      setIsLoading(true);
      apiQueryWithToken
        .post(
          tab === "1"
            ? `api/Insights/Sector/Overview`
            : `api/Insights/Sector/Benchmark`,
          {
            sectorID: value.selectedSector,
            subSectorID: value.selectedSubSector,
            areaID: value.selectedArea,
            countryID: value.selectedCountry,
            regionID: value.selectedRegion,
            ccsid: value.selectedCCS || 0,
            functionID: value.selectedFunction,
            revenueRangeID: value.selectedRevenue,
            subSubSectorID:value.selectedSubSubSectorId,
            top: value.Top ? parseInt(value.Top) : 3,
          }
        )
        .then((data) => {
          if (tab === "1") {
            setSectorData(data.data.period?.averageRevenue?.yearlyInsights);
            setKpiData(data.data.kpiPercentiles);
          } else if (tab === "2") {
            setfiltercopy({ ...value });
            setSectData({ Financial: { ...data.data.financial } });
          }
          setIsLoading(false);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            navigate("/");
          } else {
            logger.error("An error occurred:", error);
            setIsLoading(false);
          }
        });
    }
  };

  const handleDataFromChild = (data) => {
    setChildData(data);
    handleData({ ...filterCopy,selectedSector:sectorID, Top: data });
  };
  const handleChange = (event, newValue) => {
    setTab(newValue);
    getInitialData(newValue);
  };

  return (
    <React.Fragment>
      <FilterSelections
        handleData={handleData}
        viewFilter={viewFilter}
        tabValue={tab}
        onViewChange={(e) => setViewFilter(e.target.value)}
        sector={sector}
        setIsLoading={setIsLoading}
      />
      <Container maxWidth="xl">
        <div style={{ backgroundColor: "white" }}>
          <TabContext value={tab}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Overview" value="1" disabled={isLoading} />
              <Tab label="Benchmark" value="2" disabled={isLoading} />
              <Tab label="Insights" value="3" />
            </TabList>
            <TabPanel value="1" className="tab-panel">
              {isLoading && <MotifProgressLoader show variant="default" />}
              {viewFilter === "period" ? (
                <Dashboard sectorData={sectorData} isLoading={isLoading} />
              ) : (
                <KpiPercentiles kpiData={kpiData} />
              )}
            </TabPanel>
            <TabPanel value="2" className="tab-panel">
              {isLoading && <MotifProgressLoader show variant="default" />}
              {sectDataToSend.Financial?.balanceSheets?.length > 0 &&
                sectDataToSend.Financial?.profitAndLosses?.length > 0 && (
                  <Financial
                    sendDataToParent={handleDataFromChild}
                    sectorData={sectDataToSend}
                    isLoading={isLoading}
                  />
                )}
            </TabPanel>
            <TabPanel value="3" className="tab-panel">
              <InSights sector={sector} getFilterValue={getInsightsFilter} />
            </TabPanel>
          </TabContext>
        </div>
      </Container>
    </React.Fragment>
  );
};
